import React from "react";
import { withSearch } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";

function ClearFilters({ clearFilters }) {
  const {t} = useTranslation();
  return (
    <button className="p-button--reset" onClick={() => clearFilters()}>
      {t("Reset")}
    </button>
  );
}

export default withSearch(({ clearFilters }) => ({
  clearFilters
}))(ClearFilters);
